document.addEventListener("DOMContentLoaded", () => {
    const sidebars = document.querySelectorAll('.sidebar-nav');

    if(sidebars.length < 1) return;
    
    sidebars.forEach(sidebar => {
        sidebar.addEventListener("click", ()=>{
            sidebar.classList.toggle('active');
        });
    })
})